var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative"},[_c('div',{staticClass:"legend",style:('--id:' + _vm.id),attrs:{"id":'legend_' + _vm.id}}),_c('div',{staticClass:"wrapper"},[_c('canvas',{attrs:{"width":"600","height":"250","id":_vm.id}}),_c('div',{staticClass:"no-data",attrs:{"id":"no-data"}},[_vm._v("ไม่พบข้อมูล to display")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }